/* eslint-disable @typescript-eslint/naming-convention */
export interface CookieSettings {
  configured?: boolean;
  cookies_pref: 0 | 1;
  cookies_stat: 0 | 1;
  cookies_mkt: 0 | 1;
}

export const defaultCookieSettings: CookieSettings = {
  cookies_pref: 1,
  cookies_stat: 1,
  cookies_mkt: 1,
  configured: true,
};
export const defaultAcceptedCookieSettings: CookieSettings = {
  cookies_pref: 1,
  cookies_stat: 1,
  cookies_mkt: 1,
};

export const defaultRejectedCookieSettings: CookieSettings = {
  cookies_pref: 0,
  cookies_stat: 0,
  cookies_mkt: 0,
  configured: true,
};
